import { useState, useCallback } from 'react'

export function useInput(initial) {
  const [value, setValue] = useState(initial)
  const handleChange = useCallback((e) => setValue(e.target.value), [setValue])

  return [value, handleChange]
}
